import FormItem from "@/module/FormItem";

export default class FormOrderBump {
  readonly formItem: FormItem;
  readonly id: number;
  readonly name: string;
  readonly description: string | null;

  constructor(
    id: number,
    formItem: FormItem,
    name: string,
    description: string | null,
  ) {
    this.id = id;
    this.formItem = formItem;
    this.name = name;
    this.description = description;
  }
}
